/**
 * Interceptar el click de un `<a>` que apunta a una ruta de ESTA app.
 *
 * El problema
 * -----------
 * Un `<a href="/genetica/x/animal/y">` a una ruta del propio router no rutea:
 * el navegador tira abajo la aplicación entera y vuelve a bajar el bundle. En
 * el micrositio duele doble, porque estas páginas se incrustan en un iframe y
 * `useAvisarAltoAlPadre` acaba de negociar el alto con el sitio anfitrión — la
 * recarga reinicia ese handshake y el iframe pega un salto.
 *
 * Por qué no se reemplaza el `<a>` por un `<div onClick>`
 * -------------------------------------------------------
 * Porque el `href` sirve para cosas que un `div` no da: el botón del medio y
 * ctrl/cmd+click abren en otra pestaña, el click derecho ofrece "copiar
 * dirección", el navegador muestra el destino en la barra de estado, y los
 * buscadores lo siguen. Un catálogo público vive de eso. Se queda el `<a>` y se
 * intercepta SOLO el click simple.
 *
 * La sutileza que se come casi todo el mundo
 * ------------------------------------------
 * Si el handler hace `preventDefault()` a ciegas, **rompe ctrl+click**: el
 * comprador que quería abrir tres toros en tres pestañas para compararlos se
 * queda con una sola, y encima navegada. Por eso se deja pasar cualquier click
 * con modificador, y el `button !== 0` cubre el del medio en los navegadores
 * que lo reportan por `onClick`.
 */

/**
 * @param {function} navigate  El de `useNavigate()`.
 * @param {string}   destino   La ruta interna, la misma que va en el `href`.
 * @returns {function}         Handler para `onClick`.
 */
export const clickInterno = (navigate, destino) => (e) => {
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  e.preventDefault();
  navigate(destino);
};
